module.exports = __webpack_public_path__ + "static/img/Page-loader-123px.12837b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Page-loader-123px.svg
// module id = /qBh
// module chunks = 1